import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import useColor from '@/hooks/domain/useColor';
import { getAlphaColor } from '@/styles/colors/color.utils';

import { Flex } from '../base';
import Typo from '../Typography/Typo';

type Props = {
  themeColor?: string;
  icon: ReactNode;
  title: string;
  children: ReactNode;
  style?: CSSProperties;
};

const Quote = (props: Props) => {
  const color = useColor();
  return (
    <Style
      d="column"
      g={6}
      themeColor={props.themeColor || color.primary100}
      style={props.style}
    >
      <Flex g="8px" a="center">
        <div className="icon-wrapper">{props.icon}</div>
        <Typo type="label2" weight="sb" className="text-gray-700">
          {props.title}
        </Typo>
      </Flex>
      <Flex className="body-wrapper">{props.children}</Flex>
    </Style>
  );
};

const Style = styled(Flex)<{ themeColor: string }>`
  position: relative;
  background-color: ${(props) =>
    props.themeColor
      ? getAlphaColor(props.themeColor, 0.15)
      : props.theme.colors.gray200};
  color: ${(props) => props.themeColor};
  padding: 24px 32px;
  border-radius: 10px;
  .icon-wrapper {
    font-size: 16px;
  }
  .body-wrapper {
    color: ${(props) => props.theme.colors.gray700};
  }
`;

export default Quote;
